import { useLayoutEffect } from "react";
import { useDispatch } from "react-redux";
import {
  clearPageHeading,
  setPageHeading,
} from "@/components/state/pageHeading/pageHeadingSlice";

export const usePageHeading = (heading?: string) => {
  const dispatch = useDispatch();

  useLayoutEffect(() => {
    if (heading === undefined) {
      return;
    }

    dispatch(setPageHeading(heading));

    return () => {
      dispatch(clearPageHeading());
    };
  }, [dispatch, heading]);
};
